import './repositories.scss';
import './repositories.service.js';
import './ssh-keys.directive.js';

angular.module('reposTableModule')

    .directive('repositoriesTable', ['GhDialog', 'RepositoriesService', function (GhDialog, RepositoriesService) {
        return {
            restrict: 'E',
            scope: {
                repositories: '=',
                sshKeys: '='
            },

            controller: ['$scope', 'localizationService', function ($scope, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);

                if (!Array.isArray($scope.repositories)) {
                    $scope.repositories = [];
                }

                $scope.$watchCollection('repositories', function (newValue) {
                    if (!Array.isArray(newValue)) {
                        $scope.repositories = [];
                    }
                });

                $scope.getRepoTypeLabel = function (type) {
                    return RepositoriesService.getRepoTypeLabel(type);
                };

                $scope.formatDate = function (dateStr) {
                    if (!dateStr) return '—';
                    const d = new Date(dateStr);
                    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
                };

                $scope.showDeleteRepoPopup = function (repo) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'center',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            resizable: false,
                            content: `
                                <div class="delete_repo-popup">
                                    <div class="dialog-share-group">
                                        <span gh-icon="rubbish FF0D0D 65px"></span>
                                        <p class="dialog-share-group__title">Deleting Repository!</p>
                                    </div>

                                    <div class="dialog-share-group__content">
                                        <p class="info">
                                            Do you really want to delete this repository?
                                            You will not be able to restore it.
                                        </p>

                                        <div class="dialog-share-group__content__buttons">
                                            <button
                                                class="dialog-share-group__content__buttons__add btn btn-blue-reverse"
                                                ng-click="deleteRepo()"
                                            >
                                                Delete
                                            </button>

                                            <button
                                                class="dialog-share-group__content__buttons__cancel btn btn-blue"
                                                ng-click="cancel()"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            repo
                        },
                        controller: [
                            '$scope',
                            'repo',
                            'RepositoriesService',
                            function ($scope, repo, RepositoriesService) {
                                $scope.deleteRepo = async function () {
                                    try {
                                        await RepositoriesService.delete(repo._id);

                                        if (!Array.isArray(tableScope.repositories)) {
                                            tableScope.repositories = [];
                                        }

                                        const index = tableScope.repositories.findIndex(function (r) {
                                            return r._id === repo._id;
                                        });

                                        if (index !== -1) {
                                            tableScope.repositories.splice(index, 1);
                                        }

                                        tableScope.$applyAsync();
                                        $scope.cancel();
                                    } catch (error) {
                                        console.log('Repository delete error:', error);
                                    }
                                };
                            }
                        ]
                    });
                };

                $scope.showEditRepoPopup = function (repo) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'center',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            resizable: false,
                            content: `
                                <div class="edit_repo-popup">
                                    <div class="dialog-share-group">
                                        <span gh-icon="configuration 0D99FF 65px"></span>
                                        <p class="dialog-share-group__title">{{translate('Edit Repository')}}</p>
                                    </div>
                                    <div class="dialog-share-group__content">
                                        <div class="dialog-share-group__content__input" ng-if="gitClone">
                                            <label>{{translate('Git Clone')}}</label>
                                            <div class="repo-git-clone-row">
                                                <input class="repo-git-clone disable-gudhub-styles" type="text" readonly ng-value="gitClone">
                                                <span class="repo-git-clone-copy" ng-click="copyGitClone()" gh-icon="double_plus {{copied ? '00cc66' : '0d99ff'}} 20px" title="{{translate('Copy')}}"></span>
                                            </div>
                                        </div>
                                        <div class="dialog-share-group__content__input">
                                            <label>{{translate('Repository name')}}</label>
                                            <gh-input ng-model="repoName" placeholder="{{translate('Repository name')}}"></gh-input>
                                        </div>
                                        <div class="dialog-share-group__content__input">
                                            <label>{{translate('Description')}}</label>
                                            <textarea class="edit-repo-textarea disable-gudhub-styles" ng-model="description" placeholder="{{translate('Description')}}"></textarea>
                                        </div>
                                        <div class="dialog-share-group__content__input">
                                            <label>{{translate('SSH Keys')}}</label>
                                            <gh-input-list
                                                gh-editable="true"
                                                add-button-name="{{translate('Add Key')}}"
                                                gh-dropdown="sshKeyOptions"
                                                gh-model="selectedSshKeys"
                                                gh-data-type="text_opt"
                                                size="large"
                                                gh-multiple-selection="false">
                                            </gh-input-list>
                                        </div>
                                        <p class="error_message" ng-if="errMessage">{{errMessage}}</p>
                                        <div class="dialog-share-group__content__buttons">
                                            <button class="dialog-share-group__content__buttons__add btn btn-blue" ng-click="saveRepo()">
                                                {{translate('Save')}}
                                            </button>
                                            <button class="dialog-share-group__content__buttons__cancel btn btn-blue-reverse" ng-click="cancel()">
                                                {{translate('Cancel')}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            repo,
                            sshKeyOptions: ($scope.sshKeys || []).map(k => ({ name: k.name, value: k._id }))
                        },
                        controller: ['$scope', 'repo', 'sshKeyOptions', 'RepositoriesService', 'localizationService',
                            function ($scope, repo, sshKeyOptions, RepositoriesService, localizationService) {
                                const dictionary = localizationService.getDictionary('account_settings');
                                $scope.translate = (word) => localizationService.translate(word, dictionary);

                                $scope.repoName = repo.repo_name;
                                $scope.description = repo.description || '';
                                $scope.errMessage = '';
                                $scope.gitClone = repo.git_clone ? `git clone "${repo.git_clone}"` : null;
                                $scope.copied = false;
                                $scope.copyGitClone = function () {
                                    navigator.clipboard.writeText($scope.gitClone).then(function () {
                                        $scope.copied = true;
                                        $scope.$applyAsync();
                                        setTimeout(function () {
                                            $scope.copied = false;
                                            $scope.$applyAsync();
                                        }, 2000);
                                    });
                                };
                                $scope.sshKeyOptions = sshKeyOptions;
                                $scope.selectedSshKeys = (repo.ssh_keys || []).slice();

                                $scope.saveRepo = async function () {
                                    if (!$scope.repoName || !$scope.repoName.trim()) {
                                        $scope.errMessage = $scope.translate('Repository name is required');
                                        return;
                                    }
                                    try {
                                        const updated = await RepositoriesService.update(repo._id, {
                                            repo_name: $scope.repoName.trim(),
                                            description: $scope.description.trim(),
                                            ssh_keys: $scope.selectedSshKeys
                                        });
                                        repo.repo_name = updated.repo_name;
                                        repo.description = updated.description;
                                        repo.ssh_keys = updated.ssh_keys;
                                        tableScope.$applyAsync();
                                        $scope.cancel();
                                    } catch (err) {
                                        $scope.errMessage = err.message || $scope.translate('Failed to update repository');
                                    }
                                };
                            }]
                    });
                };

                $scope.openRepoIde = async function (e, repo) {
                    if (!repo._id) return;

                    await gudhub.ghconstructor.getInstance('ide');

                    GhDialog.show({
                        position: 'full',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            content: `
                                <div class="repo-editor-ide">
                                    <div class="repo-editor-ide__header">
                                        <h2>{{repoName}}</h2>
                                        <span class="close_dialog" ng-click="cancel()" gh-icon="cross 0D99FF 30px"></span>
                                    </div>
                                    <gh-ide gh-repo-id="${repo._id}"></gh-ide>
                                </div>
                            `
                        },
                        locals: {
                            repoName: repo.repo_name
                        },
                        controller: ['$scope', 'repoName', function ($scope, repoName) {
                            $scope.repoName = repoName;
                        }]
                    });
                };
            }],

            template: `
                <div class="listing_table">
                    <div class="listing_table_head_wrapper">
                        <div class="listing_table_column bottom_line w-30">
                            <div class="tab">{{translate('Name')}}</div>
                        </div>

                        <div class="listing_table_column w-20">
                            <div class="tab">{{translate('Type')}}</div>
                        </div>

                        <div class="listing_table_column w-30">
                            <div class="tab">{{translate('Last Update')}}</div>
                        </div>

                        <div class="listing_table_column w-10">
                            <div class="tab">{{translate('Settings')}}</div>
                        </div>

                        <div class="listing_table_column w-10"></div>
                    </div>

                    <div class="listing_table_body_wrapper">
                        <div
                            class="listing_table_row"
                            ng-click="openRepoIde($event, repo)"
                            ng-repeat="repo in repositories track by repo._id"
                        >
                            <div class="listing_table_column w-30">
                                <span class="number">{{$index + 1}}</span>
                                <div class="name">{{repo.repo_name}}</div>
                            </div>

                            <div class="listing_table_column w-20">
                                <div class="name">{{getRepoTypeLabel(repo.repo_type)}}</div>
                            </div>

                            <div class="listing_table_column w-30">
                                <div class="name">{{formatDate(repo.updatedAt)}}</div>
                            </div>

                            <div class="listing_table_column w-10">
                                <span
                                    ng-click="showEditRepoPopup(repo); $event.stopPropagation()"
                                    gh-icon="configuration 0d99ff 20px"
                                ></span>
                            </div>

                            <div class="listing_table_column w-10">
                                <span
                                    ng-click="showDeleteRepoPopup(repo); $event.stopPropagation()"
                                    class="delete_icon"
                                    gh-icon="rubbish 0d99ff 20px"
                                ></span>
                            </div>
                        </div>

                        <div ng-if="!repositories.length" class="listing_table_nodata">
                            <p>{{translate('No Repositories')}}</p>
                        </div>
                    </div>
                </div>
            `
        };
    }]);
